import axios from '../axios';

export type SupportedLanguage = {
  code: string
  label: string
}

export namespace LanguagesController {
  export const getLanguages = async () =>
    (await axios.get<SupportedLanguage[]>('/internal/languages')).data

  export const upsertLanguage = async (language: SupportedLanguage) =>
    (await axios.put('/internal/languages', language))

  export const deleteLanguage = async (code: string) =>
    (await axios.delete(`/internal/languages/${code}`))
}
